import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useGetErrorMessage } from '@/utils/error'
import type { ResponseError } from '@/utils/error'
import { useT } from '@/utils/language'
import { useRequest } from '@/utils/request'
import { useIkasaId } from '@/utils/setting'
import { useToast } from '@/utils/toast'

import Page from '@/components/Page'

import styles from './PlanOfficePage.module.css'

function PlanOfficePage() {
  const T = useT()
  const ikasaId = useIkasaId()
  const request = useRequest()
  const navigate = useNavigate()
  const toast = useToast()
  const getErrorMessage = useGetErrorMessage()

  const [officeCode, setOfficeCode] = useState('')
  const onSubmit = useCallback(async () => {
    try {
      await request('/service/v1/setting/payment/office', {
        method: 'POST',
        showToast: false,
        data: { ikasa_id: ikasaId, office_code: officeCode },
      })
      await request(`/service/v1/setting/user/${ikasaId}`, {
        method: 'PUT',
        showToast: false,
        data: {
          orientation_completed_at: new Date().toISOString(),
        },
      })
      navigate('/', { replace: true })
    } catch (error) {
      console.error('Failed to sign up office plan:', error)
      toast(getErrorMessage(error as ResponseError), 'error')
    }
  }, [request, ikasaId, officeCode, navigate, toast, getErrorMessage])

  return (
    <Page className={styles.page} title={T('officePlanSignUp')}>
      <div className={styles.title}>{T('officePlanCode')}</div>
      <input
        className={styles.input}
        value={officeCode}
        placeholder={T('inputText')}
        onChange={(e) => {
          setOfficeCode(e.target.value)
        }}
      />
      <button className={styles.button} onClick={onSubmit}>
        {T('planSignUp')}
      </button>
    </Page>
  )
}

export default PlanOfficePage
